<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>User KYC - <span>{{username | titlecase}} </span>
                    <span>({{mobileNumber}})</span>
                    <span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn">
                    <span>
                        <img src="../../../assets/images/backend-image/header/exportIcon.svg" alt="">
                    </span> Export
                </button> -->
            </div>
        </div>
        <div class="mainDivBody">
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table class="p2-table-columns show-columns" #dt [value]="userlist" [lazy]="true"
                        (onLazyLoad)="loadUserKyc($event)" [totalRecords]="totalRecords" [loading]="loading"
                        autoLayout="true" styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <!-- <th style="min-width: 100px;">Pan Image</th> -->
                                <th class="bankDetails-td">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Bank Details

                                    </div>
                                </th>
                                <!-- <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                A/C Number
                            </div>
                        </th>
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                IFSC
                            </div>
                        </th> -->
                                <th>
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Pan Number
                                    </div>
                                </th>
                                <th>
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Aadharcard Number
                                    </div>
                                </th>
                                <th>
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        GST Number
                                    </div>
                                </th>

                                <!-- <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                State Name

                            </div>
                        </th>
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                City Name

                            </div>
                        </th> -->
                                <th class="address-td">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Address

                                    </div>
                                </th>
                                <!-- <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Zip Code

                            </div>
                        </th> -->
                                <th>
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Date
                                    </div>
                                </th>
                                <th class="status-Td">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Status
                                    </div>
                                </th>

                                <!-- <th class="">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Action
                            </div>
                        </th> -->

                            </tr>

                        </ng-template>
                        <ng-template pTemplate="body" let-userlist>
                            <tr class="p-selectable-row" *ngIf="noData">

                                <!-- <td class="pan-image-td"> 
                            <div class="pan-image"  (click)="openHightlightImage(userlist);"> 
                                <img [src]=userlist.pancardPic [alt]="userlist.name" 
                                width="300" class="shadow-4" />
                            </div>
                          <div class="button-div"  (click)="openHightlightImage(userlist);">
                            <button pButton pRipple type="button" icon="pi pi-eye"  class="p-button-rounded"></button>
                            <p>View Image</p>
                          </div>
                          </td> -->
                                <td class="bankDetails-td">
                                    <span *ngFor="let bankdata of userlist.bankData">
                                        <span><b>Bank Name:</b> {{bankdata.bankName}}</span>
                                        <span><b>A/C Number:</b> {{bankdata.bankAccountNumber}}</span>
                                        <span><b>IFSC Number:</b> {{bankdata.ifsc}}</span>
                                    </span>
                                </td>

                                <!-- <td>
                            {{userlist.accountNumber}}
                        </td>
                        <td>
                            {{userlist.ifsc}}
                        </td> -->
                                <td>
                                    {{userlist.panCardNumber}}
                                </td>
                                <td>
                                    {{userlist.aadhaarCardNumber}}
                                </td>

                                <td>
                                    {{userlist.gstNumber}}
                                </td>

                                <!-- <td>
                            {{userlist.statename}}
                        </td>
                        <td>
                            {{userlist.cityname}}
                        </td> -->
                                <td class="address-td">
                                    <span *ngIf="userlist.isAadharVerified">
                                        {{userlist.fullAddress?.house}},{{userlist.fullAddress?.street}},{{userlist.fullAddress?.landmark}},{{userlist.fullAddress?.po}}-{{userlist.fullAddress?.pincode}},{{userlist.fullAddress?.state}},{{userlist.fullAddress?.country}}</span>
                                </td>
                                <!-- <td>
                            {{userlist.zipcode}}
                        </td> -->
                                <td>
                                    {{userlist.created_at | date:'dd/MM/yyyy'}}
                                </td>
                                <td class="status-Td">
                                    <p-tag class="bg-success text-white" *ngIf="userlist.isDocumentComplete"
                                        [rounded]="true">Approved</p-tag>
                                    <p-tag class="bg-warning text-dark" *ngIf="!userlist.isDocumentComplete"
                                        [rounded]="true">Pending</p-tag>
                                    <!-- <button class="bg-danger text-white" (click)="viewRejectReasonModal(userlist)" *ngIf="!userlist.status && userlist.isRejected "
                            pTooltip="Click to view Reason"  [rounded]="true">Rejected</button> -->
                                </td>
                                <!-- <td class="action-button-td">
                            <div class="status-button w-100">
                                <p-button icon="pi pi-pencil" [ngClass]="{'disabled-button-class': userlist.isRejected}" [rounded]="true" severity="warning" [disabled]="userlist.isRejected"  class="buttons btn btn-warning " routerLink="/manage/user/kyc/add-kyc/{{userlist.Id}}/0/{{userlist.userId}}"  pTooltip="Edit " tooltipPosition="bottom"> </p-button>
                                <p-button icon="pi pi-check"  [ngClass]="{'disabled-button-class': !userlist.isDocumentComplete || userlist.status || userlist.isRejected}" [rounded]="true" severity="success" [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected"  class="buttons btn btn-success" (click)="changeStatus(userlist)" pTooltip="Approved " tooltipPosition="bottom"> </p-button>
                                <p-button icon="pi pi-times"  [ngClass]="{'disabled-button-class': !userlist.isDocumentComplete || userlist.status || userlist.isRejected}"  [rounded]="true" severity="danger" [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected" class="buttons btn btn-danger" (click)="showrejectmodal(userlist)" pTooltip="Reject" tooltipPosition="bottom"> </p-button>
                            </div>
                        </td> -->

                                <!-- <td>
                            <button [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected"
                                class="btn btn-success" (click)="changeStatus(userlist)"> Approve </button>
                            <button [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected"
                                class="btn btn-danger" (click)="showrejectmodal(userlist)"> Reject </button>

                            <button pButton pRipple icon="pi pi-pencil" [disabled]="userlist.isRejected"
                                class="p-button-rounded p-button-success p-mr-2" pTooltip="edit"
                                routerLink="/manage/user/kyc/add-kyc/{{userlist.Id}}/0/{{userlist.userId}}"></button>
                        </td> -->

                                <!-- <td  class="actionTD">

                        </td> -->

                            </tr>
                        </ng-template>
                        <!-- <ng-template pTemplate="summary"  >
                    <div  class="flex align-items-center justify-content-between">
                        In total there are {{totalRecords}} KYC records     </div>
                </ng-template> -->
                <ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="9">In total there are {{totalRecords}} KYC records</td>
							</tr>
						</ng-template>
                    </p-table>

                </div>
            </div>
        </div>
    </div>
</div>


<p-galleria [(value)]="userlist" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-userlist>
        <img [src]=showHighlightImg [alt]="userlist.name" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>
<p-dialog header="Mention Reject Reason" [(visible)]="rejectKyc" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" class="modal-payment-select">
    <form [formGroup]="rejectUpdateForm">
        <div class="p-grid">
            <div class="col-12">
                <div class="form-div">
                    <textarea pInputTextarea rows="5" formControlName="comment"
                        [ngClass]="{ 'is-invalid': submitted && f.comment.errors }"></textarea>
                    <div *ngIf="((submitted && f.comment.errors) || (f.comment.errors && (f.comment.dirty || f.comment.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.comment.errors.required">
                            Reason is required</div>
                    </div>
                </div>
            </div>
            <div class="col-12 footer-forms">
                <button class="btn btn-danger" (click)="changeStatusToReject()" type="submit"> Reject </button>
            </div>
        </div>
    </form>
</p-dialog>
<p-dialog header="Reason of Rejection" [(visible)]="rejectKycReasonView" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" class="modal-payment-select">
    <div>
        {{viewReason}}
    </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>